function goodColors (){
  $(".toColor").each(function(index){
    var color = $(this).attr("data-color");
    $(this).css("color",color)
  })
}

module.exports = function () {
  goodColors()
  $(".open-marques").on("click", function(){
    var idToOpen = $(this).attr("data-id");
    $("#"+idToOpen).show()
  })
  $(".close").on("click",function(){
    var idToClose = $(this).attr("close-id");
    $("#"+idToClose).hide()
  })
  return true;
};



//////////////////
// WEBPACK FOOTER
// ./app/pages/index/js/fournisseurs.js
// module id = 10
// module chunks = 0